import * as React from 'react';
import * as classNames from 'classnames';
import { IDynamicComponentProps } from '../dynamic_component_props';

import SanitizedRender from '../../components/sanitized_render';

import { YOUTUBE_VIDEO, VIMEO_VIDEO } from '../../url_helpers';

const VIMEO = 'vimeo';

export interface IProps extends IDynamicComponentProps {
  slug: string;
  caption?: string;
  captionHtml?: string;
  description?: string;
  descriptionHtml?: string;
  narrow?: boolean;
  withBackground?: boolean;
  platform?: string;
}

export default class VideoEmbed extends React.Component<IProps, null> {
  url() {
    const { slug } = this.props;

    if (this.props.platform === VIMEO) {
      return VIMEO_VIDEO.expand({ slug });
    }

    return YOUTUBE_VIDEO.expand({ slug });
  }

  render() {
    if (!this.props.slug) return null;

    const classes = classNames(
      'video-embed',
      { 'video-embed--narrow': this.props.narrow },
      { 'video-embed--with-description': !!this.props.descriptionHtml },
      { 'video-embed--with-background': this.props.withBackground },
    );

    return (
      <div className={classes}>
        <div className="video-embed__wrapper">
          <div className="video-embed__overhang">
            <div className="video-embed__columns">
              <div className="video-embed__column">
                <div className="video-embed__inner">
                  <iframe
                    title={this.props.caption || this.props.captionHtml}
                    src={this.url()}
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              </div>
              <div className="video-embed__column">
                <SanitizedRender
                  className="video-embed__caption"
                  html={this.props.captionHtml || this.props.caption}
                  htmlTag="div"
                />
                <SanitizedRender
                  className="video-embed__description"
                  html={this.props.descriptionHtml || this.props.description}
                  htmlTag="div"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/cms/components/video_embed.tsx